import $ from 'jquery'
import Barba from 'barba.js'

Barba.Pjax.Dom.wrapperId = 'js-pjax-wrapper'
Barba.Pjax.Dom.containerClass = 'js-pjax-container'

Barba.Pjax.start()
Barba.Prefetch.init()

var shutter = $('#js-shutter')
var loader = $('#js-loader')
var body = $('body')

/* eslint-disable no-unused-vars */
var DefaultTransition = Barba.BaseTransition.extend({
  start: function() {
    Promise.all([this.newContainerLoading, this.PageLeave()]).then(this.PageEnter.bind(this))
  },

  PageLeave: function() {
    return $(this.oldContainer)
      .delay(900)
      .animate({ opacity: 0 })
      .promise()
  },

  PageEnter: function() {
    var _this = this
    var $el = $(this.newContainer)

    $(this.oldContainer).hide()

    $('html, body').scrollTop(0)

    $el.css({
      visibility: 'visible',
      opacity: 0
    })

    $el.animate({ opacity: 1 }, 900, function() {
      _this.done()
    })
  }
})

Barba.Pjax.getTransition = function() {
  return DefaultTransition
}

Barba.Dispatcher.on('linkClicked', function(HTMLElement, MouseEvent) {
  loader.delay(600).fadeIn(300)
  body.addClass('state-loading').removeClass('state-loaded')
  shutter.show().addClass('js-leave')
})

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {
  if (Barba.HistoryManager.history.length === 1) {
    return
  }
  var $newPageHead = $('<head />').html($.parseHTML(newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true))
  var headTags = [
    "meta[name='keywords']",
    "meta[name='description']",
    "meta[property^='og']",
    "meta[name^='twitter']",
    'meta[itemprop]',
    'link[itemprop]',
    "link[rel='prev']",
    "link[rel='next']",
    "link[rel='canonical']",
    "link[rel='alternate']"
  ].join(',')
  $('head')
    .find(headTags)
    .remove()
  $newPageHead.find(headTags).appendTo('head')
})

Barba.Dispatcher.on('initStateChange', function() {
  if (typeof ga === 'function') {
    ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search)
  }
})

Barba.Dispatcher.on('transitionCompleted', function(HTMLElement, MouseEvent) {
  loader.fadeOut(300)
  shutter.removeClass('js-leave').addClass('js-appear')
  setTimeout(function() {
    shutter.hide().removeClass('js-appear')
  }, 1000)
  body.removeClass('state-loading').addClass('state-loaded')

  $('#js-burger-toggle').click(function() {
    $('#js-header').toggleClass('js-active')
  })

  $("a[href^='#']").click(function() {
    var speed = 500
    var href = $(this).attr('href')
    var target = $(href == '#' || href == '' ? 'html' : href)
    var position = target.offset().top
    $('body,html').animate(
      {
        scrollTop: position
      },
      speed,
      'swing'
    )
    return false
  })

  $(function() {
    var ua = navigator.userAgent
    if (ua.indexOf('iPhone') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
      $('a[href^="tel:"]').css('pointer-events', 'auto')
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      $('a[href^="tel:"]').css('pointer-events', 'none')
    } else {
      $('a').addClass('js-hover')
      $('a[href^="tel:"]').css('pointer-events', 'none')
      if ($('.js-hover').length) {
        $('.js-hover').hover(
          function() {
            $(this).addClass('hover')
          },
          function() {
            $(this).removeClass('hover')
          }
        )
      }
    }
  })

  if ($('#js-mv-slider').length) {
    $(function() {
      $('#js-mv-slider').slick({
        autoplay: true,
        arrows: false,
        fade: true,
        autoplaySpeed: 4000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false
      })
    })
  }
})

/* eslint-enable no-unused-vars */
